import * as s from "./mockup-ipad.module.less";
import iPadImage from "../../../media/mockups/ipad.png";
import React from "react";
import {GatsbyImage as Img, getImage} from "gatsby-plugin-image";

const MockupIPad = ({
	screenShot,
	companyName
}) => {
	return (
		<div className={s.mockup}>
			<img
				src={iPadImage}
				alt={`${companyName} media`}
				className={s.mockImage}
			/>
			<div
				className={s.mediaElement}
			>
				<Img
					image={getImage(screenShot)}
					alt={`${companyName} media`}
				/>
			</div>
		</div>
	)
}
export default MockupIPad;
